export class Contact {
	emailaddress: string = '';
    contactsupport: string = '';
    name: string = '';
    phonenumber: string = '';
  message: string = '';
  Emailsubject: string = '';
}
